export interface PriceTier {
    qty: number;
    price: number;
    price_canadian_dollar: number;
    type: string;
}

export const PRICE_TIERS: PriceTier[] = [];

export const FLEET_PRICE_TIERS: PriceTier[] = [];